import { Component } from '@angular/core';
import { UiBadgeComponent } from '@shared/ui-badge/ui-badge.component';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [UiBadgeComponent]
})
export class HeaderComponent { }